import React from "react";
import { BadgeWrapper } from "../badge";

import { IconButton } from "../icon-button";

export enum BadgeType {
	"error",
	"warning",
}
interface IFloatingMenuButtonProps {
	onClick: () => void;
	badgeType: BadgeType | null;
}

const FloatingBadge = ({ badgeType }: { badgeType: BadgeType | null }) => {
	if (badgeType !== null) {
		if (badgeType === BadgeType.warning)
			return <BadgeWrapper className="floating-menu__badge--warning" />;
		if (badgeType === BadgeType.error)
			return <BadgeWrapper className="floating-menu__badge--error" />;
	}

	return null;
};

export function FloatingMenuButton({ onClick, badgeType }: IFloatingMenuButtonProps) {
	return (
		<>
			<IconButton iconName="dots-vertical" onClick={onClick} elevated />
			<FloatingBadge badgeType={badgeType} />
		</>
	);
}
